document.addEventListener('DOMContentLoaded', () => {
    const prevButton = document.querySelector('.splide__arrow--prev');
    const nextButton = document.querySelector('.splide__arrow--next');
    const prevBtnWrapper = document.getElementById('prev');
    const nextBtnWrapper = document.getElementById('next');

    function updateButtonState(button, buttonWrapper) {
        if (button.disabled) {
            buttonWrapper.classList.add('text-opacity-25');
        } else {
            buttonWrapper.classList.remove('text-opacity-25');
        }
    }

    if (prevButton && nextButton) {
        updateButtonState(prevButton, prevBtnWrapper);
        updateButtonState(nextButton, nextBtnWrapper);

        prevBtnWrapper.addEventListener('click', () => {
            prevButton.click();
            updateButtonState(prevButton, prevBtnWrapper);
            updateButtonState(nextButton, nextBtnWrapper);
        });

        nextBtnWrapper.addEventListener('click', () => {
            nextButton.click();
            updateButtonState(prevButton, prevBtnWrapper);
            updateButtonState(nextButton, nextBtnWrapper);
        });
    }
});
